export { default } from "./ShippingTag.jsx";
